import React from "react";
import { Accordion, AccordionDetails, AccordionSummary, Chip, Stack, Typography } from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import Grid2 from "@mui/material/Grid2";
import SupplierCard from "./SupplierCard";

const SupplierGroupList = ({ groups, onEdit, onDelete }) => (
    <Stack spacing={2}>
        {groups.map((group) => (
            <Accordion key={group.key} defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreRoundedIcon />}>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
                            {group.key}
                        </Typography>
                        <Chip size="small" label={group.suppliers.length} />
                    </Stack>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid2 container spacing={2}>
                        {group.suppliers.map((supplier) => (
                            <Grid2 key={supplier.id} xs={12} sm={6} md={4}>
                                <SupplierCard supplier={supplier} onEdit={onEdit} onDelete={onDelete} />
                            </Grid2>
                        ))}
                    </Grid2>
                </AccordionDetails>
            </Accordion>
        ))}
    </Stack>
);

export default SupplierGroupList;
